// Components/ui
import { Body } from './components';
import { SubsectionHeaderWithButton } from '../../layout';
// Types
import { NewAddress } from '../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';
import { Box } from '@mui/material';
import { useTranslationContext } from '../../../../../../../context/TranslationContext';

type Props = {
  phoneNumbers: Array<NewAddress | IContactAddress>;
  handleAdd: () => void;
};

const Phones = ({ phoneNumbers, handleAdd }: Props) => {
  const t = useTranslationContext();
  return (
    <Box sx={{ width: '100%' }}>
      <SubsectionHeaderWithButton handleAdd={handleAdd} title={t('global.phones')} />
      <Body phoneNumbers={phoneNumbers} />
    </Box>
  );
};

export default Phones;
